import cn from 'classnames';
import * as React from 'react';
import { UIHeading4 } from '@cian/ui-kit';

import * as styles from './MessageBubble.css';
import { EMarkBlockType, MarkBlock } from './MarkBlock';

export interface IMessageBubbleProps {
  title?: string;
  text?: string;
  positive?: string | null;
  negative?: string | null;
  className?: string;
  /** Необходимо при использовании useBubbleClamp */
  rootRef?: React.MutableRefObject<HTMLDivElement | null>;
  /** Необходимо при использовании useBubbleClamp */
  textClassName?: string;
  expandButton?: React.ReactNode;
}

export const MessageBubble = ({
  rootRef,
  title,
  text,
  positive,
  negative,
  className,
  textClassName,
  expandButton,
}: IMessageBubbleProps) => {
  const withMark = positive || negative;
  const onlyTitle = !text && !withMark;

  return (
    <div ref={rootRef} className={cn(styles['root'], !withMark && styles['root_without-marks'], className)}>
      {title && (
        <div className={cn(styles['title'], onlyTitle && styles['title_only-title'])}>
          <UIHeading4>{title}</UIHeading4>
        </div>
      )}

      {text ? (
        <div className={styles['text-container']}>
          <p className={cn(styles['text'], textClassName)}>{text}</p>
        </div>
      ) : (
        <>
          {positive && (
            <MarkBlock type={EMarkBlockType.POSITIVE} textClassName={textClassName}>
              {positive}
            </MarkBlock>
          )}
          {negative && (
            <MarkBlock type={EMarkBlockType.NEGATIVE} textClassName={textClassName}>
              {negative}
            </MarkBlock>
          )}
        </>
      )}
      {expandButton}
    </div>
  );
};
